<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :items="items" :title="title" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_length"></div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_filter text-md-end">
                  <!-- <b-button v-b-modal.upload-modal variant="success"><i class="fa fa-upload"></i> Import Items</b-button> |-->
                  <b-button
                    v-if="user_permissions.add_pharmacy_item"
                    v-b-modal.items-modal
                    variant="primary"
                    ><i class="fa fa-plus"></i> New Item</b-button
                  >
                  <b-button disabled v-else v-b-modal.items-modal variant="primary"
                    ><i class="fa fa-ban"></i> New Item</b-button
                  >

                  <!--ADDING NEW SERVICE MODAL-->
                  <b-modal
                    id="items-modal"
                    ref="modal"
                    hide-footer
                    title="Add New Item"
                    @hidden="resetAddModal"
                  >
                    <div class="mb-2">
                      <label class="col-form-label" for="item-name">Item Name:</label>
                      <input
                        id="item-name"
                        v-model="data.name"
                        class="form-control"
                        required
                        type="text"
                        @keyup="checkName"
                        placeholder="E.g Gloves"
                      />
                      <div class="text-danger" v-if="nameError">
                        <em>{{ nameError }}</em>
                      </div>
                    </div>
                    <div class="mb-2">
                      <label class="col-form-label" for="minimum-stock"
                        >Minimum Stock:</label
                      >
                      <input
                        id="minimum-stock"
                        v-model="data.min_stock"
                        class="form-control"
                        required
                        type="text"
                        placeholder="E.g 100"
                      />
                      <div class="text-info">
                        <em
                          >Get notified when the stock level goes below Minimum Stock</em
                        >
                      </div>
                    </div>
                    <div class="mb-2">
                      <label class="col-form-label" for="current-stock"
                      >Current Stock:</label
                      >
                      <input
                          id="current-stock"
                          v-model="data.in_stock"
                          class="form-control"
                          required
                          type="text"
                          placeholder="E.g 100"
                      />
                      <div class="text-info">
                        <em
                        >Items currently in Stock</em
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-form-label">Unit Measure:</label>
                      <input
                        v-model="data.unit"
                        class="form-control"
                        list="unitx"
                        placeholder="Enter Unit"
                        autocomplete="off"
                      />
                      <datalist id="unitx">
                        <option v-for="(unit, u) in Units" :data-value="unit.id" :key="u">
                          {{ unit.symbol ? unit.symbol : "unit" }}
                        </option>
                      </datalist>
                    </div>
                    <div class="text-danger" v-if="unitError">
                      <em>{{ unitError }}</em>
                    </div>
                    <div class="modal-footer">
                      <button
                        class="btn btn-danger"
                        @click="$bvModal.hide('items-modal')"
                        type="button"
                      >
                        <i class="fa fa-times"></i> Close
                      </button>
                      <button
                        v-if="existingItem.length"
                        class="btn btn-info"
                        disabled
                        title="This Item already exists"
                        type="button"
                      >
                        <i class="fa fa-ban"></i> Save Service
                      </button>
                      <button
                        v-else
                        class="btn btn-primary"
                        type="button"
                        @click="saveItem('items-modal')"
                      >
                        <i class="fa fa-check"></i> Save Service
                      </button>
                    </div>
                  </b-modal>

                  <!--EDITING SERVICE MODAL-->
                  <b-modal
                    id="edit-modal"
                    centered
                    ref="modal"
                    hide-footer
                    :title="editData.name"
                    @hidden="resetEditModal"
                  >
                    <form ref="form" @submit.stop.prevent="saveChanges">
                      <div class="mb-2">
                        <label class="col-form-label" for="name">Item Name:</label>
                        <input
                          id="name"
                          v-model="editData.name"
                          class="form-control"
                          type="text"
                        />
                        <div class="text-danger" v-if="nameError">
                          <em>{{ nameError }}</em>
                        </div>
                      </div>
                      <div class="mb-2">
                        <label class="col-form-label">Unit Measure:</label>
                        <model-list-select
                          :list="this.Units ? this.Units : []"
                          v-model="editData.unit"
                          option-value="id"
                          option-text="unitName"
                          placeholder="Change Unit Measure"
                        >
                        </model-list-select>
                        <div class="text-danger" v-if="unitError">
                          <em>{{ unitError }}</em>
                        </div>
                      </div>
                      <div class="mb-2">
                        <label class="col-form-label" for="minimum">Minimum Stock:</label>
                        <input
                          id="minimum"
                          v-model="editData.min_stock"
                          class="form-control"
                          required
                          type="text"
                          placeholder="E.g 100"
                        />
                        <div class="text-info">
                          <em
                            >Get notified when the stock level goes below Minimum
                            Stock</em
                          >
                        </div>
                      </div>
                    </form>
                    <div class="modal-footer">
                      <button
                        class="btn btn-danger"
                        @click="$bvModal.hide('edit-modal')"
                        type="button"
                      >
                        <i class="fa fa-times"></i> Close
                      </button>
                      <button
                        v-if="existingItem.length"
                        class="btn btn-info"
                        disabled
                        title="This Service already exists"
                        type="button"
                      >
                        <i class="fa fa-ban"></i> Save Service
                      </button>
                      <button
                        v-else
                        class="btn btn-primary"
                        type="button"
                        @click="handleEditModal('edit-modal')"
                      >
                        <i class="fa fa-check"></i> Save Service
                      </button>
                    </div>
                  </b-modal>

                  <!--DELETING SERVICE MODAL-->
                  <b-modal
                    id="delete-modal"
                    header-bg-variant="warning"
                    header-text-variant="light"
                    ref="modal"
                    size="sm"
                    centered
                    @hidden="resetDeleteModal"
                    @ok="confirmDelete('delete-modal')"
                  >
                    <template #modal-title> Delete Item {{ deleteData.name }}</template>
                    <div class="d-block text-center">
                      <h5>
                        Are you sure you want to delete this Item <br />
                        Click <code>OK</code> to continue
                      </h5>
                    </div>
                  </b-modal>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      :options="pageOptions"
                      class="form-select form-select-sm"
                      size="sm"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      class="form-control form-control-sm ms-2"
                      placeholder="Search..."
                      type="search"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :current-page="currentPage"
                :fields="fields"
                :filter="filter"
                :filter-included-fields="filterOn"
                :items="this.LabItems"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                bordered
                class="datatables"
                responsive="sm"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(minimum)="data"
                  >{{ data.item.minStock }}
                  {{ data.item.unit ? data.item.unit.symbol : "" }}</template
                >
                <template #cell(action)="data">
                  <!-- Edit Modal -->
                  <b-button
                    v-if="user_permissions.edit_pharmacy_item"
                    v-b-modal.edit-modal
                    size="sm"
                    variant="primary"
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit
                  </b-button>
                  <b-button
                    v-else
                    v-b-modal.edit-modal
                    size="sm"
                    disabled
                    variant="primary"
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit
                  </b-button>
                  |
                  <!-- Delete Modal -->
                  <b-button
                    v-if="user_permissions.delete_pharmacy_item"
                    v-b-modal.delete-modal
                    size="sm"
                    variant="danger"
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete
                  </b-button>
                  <b-button
                    v-else
                    v-b-modal.delete-modal
                    size="sm"
                    disabled
                    variant="danger"
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete
                  </b-button>
                </template>
              </b-table>
              <h3 v-if="!this.LabItems" class="text-primary text-center">
                <b-spinner class="m-0" role="status" variant="primary"></b-spinner>
                Please wait...
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  page: {
    title: "Inventory Section",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },

  data() {
    return {
      title: "Inventory Items",
      items: [
        {
          text: "Inventory Section",
          href: "#",
        },
        {
          text: "Inventory Items",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100, 250, 500, 1000],
      drugOptions: [
        { id: 1, name: "True" },
        { id: 2, name: "False" },
      ],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "itemName",
          sortable: true,
          label: "ITEM NAME",
        },
        {
          key: "minimum",
          sortable: true,
          label: "MINIMUM STOCK",
        },
        {
          key: "branch.branchName",
          sortable: true,
          label: "BRANCH",
        },
        {
          key: "addedBy.name",
          sortable: true,
          label: "ADDED BY",
        },
        {
          key: "dateCreated",
          sortable: true,
          label: "ADDED ON",
        },
        {
          key: "action",
          sortable: false,
          label: "ACTION",
        },
      ],
      data: {
        name: "",
        min_stock: "5",
        unit: "",
        in_stock: "0",
      },
      existingItem: [],
      nameError: "",
      unitError: "",
      modal_id: "",
      editData: {
        name: "",
        min_stock: "",
        unit: "",
      },
      deleteData: {
        id: "",
        name: "",
      },
    };
  },

  computed: {
    ...mapGetters("pharmacy", ["Units"]),
    ...mapGetters("inventory", ["LabItems", "SaveStatus"]),
    ...mapGetters("auth", ["user_permissions"]),
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),

    rows() {
      return this.LabItems ? this.LabItems.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.LabItems ? this.LabItems.length : 1;
  },
  watch: {
    notification_show(newValue) {
      if (newValue === true) {
        this.closeModal(this.modal_id);
        if (this.notificationtype === "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchUnits: "pharmacy/fetchUnits",
      FetchLabItem: "inventory/fetchLabItems",
      SubmitItem: "inventory/addLabItem",
      SubmitUpdates: "inventory/editLabItem",
      DeleteItem: "inventory/deleteLabItem",
    }),

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering Separator
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingItem = this.LabItems.filter((service) => {
          return service.itemName.toUpperCase() == this.data.name.toUpperCase();
        });
        if (this.existingItem.length) {
          this.nameError = this.data.name + " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existingItem = [];
      }
    },

    //==========================================================
    saveItem(modalId) {
      this.modal_id = modalId;
      //Now validate for required fields
      if (this.data.name == "") {
        this.nameError = "Item name is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.unit == "") {
        this.unitError = "Unit measure is required";
        return;
      } else {
        this.unitError = "";
      }

      // Push the data submitted to the endpoint
      this.SubmitItem(this.data);
    },

    //Now reset the add modal
    resetAddModal() {
      this.data.name = "";
      this.data.min_stock = "5";
      this.data.in_stock = "0";
      this.data.unit = "";

      this.nameError = "";
      this.unitError = "";

      this.existingItem = [];
    },

    //==================================================
    showEditModal(data) {
      this.editData.id = data.item.id;
      this.editData.name = data.item.itemName;
      this.editData.min_stock = data.item.minStock;
      this.editData.unit = data.item.unit.id;
    },

    handleEditModal() {
      this.saveChanges();
    },

    saveChanges() {
      this.modal_id = "edit-modal";
      //Now validate for required fields
      if (this.editData.name == "") {
        this.nameError = "Item name is required";
        return;
      } else {
        this.nameError = "";
      }
      // Push the data submitted to the endpoint
      this.SubmitUpdates(this.editData);
    },

    resetEditModal() {
      this.editData.id = "";
      this.editData.name = "";
      this.editData.min_stock = "";
      this.editData.unit = "";
    },

    //====================================================
    showDeleteModal(data) {
      this.deleteData.name = data.item.itemName;
      this.deleteData.id = data.item.id;
    },
    confirmDelete(modalId) {
      this.modal_id = modalId;
      // Push the data submitted to the endpoint
      this.DeleteItem(this.deleteData);
    },
    resetDeleteModal() {
      this.deleteData.id = "";
      this.deleteData.name = "";
    },

    // CLOSE MODEL
    closeModal(modelId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modelId);
      });
    },
  },

  created() {
    this.FetchUnits();
    this.FetchLabItem();
  },
};
</script>
<style lang="css" scoped></style>
